// extracted by mini-css-extract-plugin
export default {"container":"roundLogo_container__D8X+K","image":"roundLogo_image__ZltiY"};